export default "__VITE_ASSET__BUzh8UBQ__"